export default "__VITE_ASSET__668a25a7__"